import * as React from "react";
import SideBarContainer from "./sidebar/SideBarContainer";

const SideBar = (props) => {
  return <SideBarContainer {...props} />;
};

export default SideBar;
